import { type App } from 'vue';

// Import the global options.
import type { PreconJobsGlobalOptions } from '@precon-tools-suite-by-shared/shared-jobs-ui';
import { registerPartial } from '@precon-tools-suite-by-shared/vue-partials';

// Export the
export type { PreconJobsGlobalOptions };
export { default as JobButton } from './components/JobButton.vue';
export { default as EchoFilesJobButton } from './components/EchoFilesJobButton.vue';

import uiPlugin from '@precon-tools-suite-by-shared/shared-jobs-ui';

// The definition of the plugin that installs the
export default {
    install(app: App, options?: PreconJobsGlobalOptions) {
        app.use(uiPlugin, options);

        registerPartial(
            app,
            '@precon-tools-suite-by-shared/shared-jobs-feature/partials/MyJobs',
            () => import('./partials/MyJobs.vue')
        );
    },
};
